import React, { useState, useCallback, useContext} from 'react'
import {useHistory} from "react-router-dom"
import Button from './button'
import './button.css'
import Subheader from './subheader'
import LodgingItinerary from './lodgingItinerary'
import CalculatorContext from '../Context'
import api from '../api/api'

function Lodging() {
  const context = useContext(CalculatorContext);
  const {setLodging} = context;
  const itineraries = context.lodgingItineraries;
  const setItineraries = context.setLodgingItineraries;
  const history = useHistory();

  const calculate= useCallback( (newItineraries)=>{
    const totals = newItineraries.reduce((prev, it)=>{      
      prev.nights += it.nights;
      prev.rooms += it.rooms;
      return prev
    },{nights:0, rooms:0})
    api.getLodgingEmissions(totals.nights, totals.rooms)
    .then((response)=>{
      setLodging(response.data);
    })
  }, [setLodging])

  const addNewItinerary = useCallback( () =>{
    const newItineraries = itineraries.slice()
    newItineraries.push({nights:1, rooms:1})
    setItineraries(newItineraries)
    calculate(newItineraries)
  }, [itineraries, calculate, setItineraries]);

  const deleteItinerary =useCallback((index)=>{    
    const newItineraries = itineraries.slice()
    newItineraries.splice(index,1)
    setItineraries(newItineraries)
    calculate(newItineraries)
  },[itineraries,calculate,setItineraries])

  const changeItinerary = useCallback((index,value)=>{        
    const newItineraries = itineraries.slice()
    newItineraries.splice(index,1,value)
    setItineraries(newItineraries)    
    calculate(newItineraries)
  }, [itineraries, calculate, setItineraries])

  return (
    <div className="lodging">
      <Subheader>
        Lodging
      </Subheader>      
      {itineraries.map((itinerary, index)=>
        <LodgingItinerary index={index} itinerary={itinerary} onChange={changeItinerary} onDelete={deleteItinerary}/>
      )}
      <div className="small-tip">
      Need to add additional lodging?
      </div>
      <div className="buttons">
        <Button className="initial-button primary another" onClick={addNewItinerary}>
          ADD MORE LODGING
        </Button>
      </div>
      <div className="buttons ">
        
          <Button showImage={false} className="primary initial-button" onClick={()=>history.push('/driving') }>
            BACK
          </Button>
          <Button className="primary initial-button" onClick={()=>history.push('/review') }>
            NEXT
          </Button>
        
      </div>
    </div>
  )
}

export default Lodging